/// <reference types="vite/client" />

// Define the shape of our environment variables
interface EnvVars {
  // Vite's built-in env variables. No prefix needed.
  MODE: string // Replaces NODE_ENV functionality - will be either 'development', 'production', or 'test'
  DEV: boolean // Boolean flag for development mode
  PROD: boolean // Boolean flag for production mode
  BASE_URL: string // The base URL of the application

  VITE_API_BASE: string

  // Tealium and Logging
  /**
   * `"dev" | "qa" | "prod"`
   * - uat uses "qa"
   */
  VITE_TEALIUM_TARGET_ENV: string

  /**
   * `"true" | "false"`
   * - as string because it's an env variable
   */
  VITE_ENABLE_LOGGING: string

}

declare global {
  interface Window {
    env?: Partial<EnvVars>
  }
}

// Export env object that combines Vite's env with window.env
export const env = {
  ...import.meta.env,
  ...window.env,
} as EnvVars
